import  gql  from 'graphql-tag'

export const CREATE_ANALYST_TYPE = gql`mutation analystType($input: AnalystTypeMutationInput!){
    analystType(input: $input){
        analystType{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;